import type { FormField } from '@lucid/lego';
import type { FieldValues } from 'react-hook-form';

/**
 * Default values for the Send Docusign form
 */
type SendDocusignFormDefaultValues = {
  firstName?: string;
  lastName?: string;
  email?: string;
  placeOnHold?: boolean;
};

/**
 * Callbacks for the Send Docusign form buttons
 */
type SendDocusignFormCallbacks = {
  onCancel?: () => void;
};

/**
 * Form fields configuration for the Send Docusign form
 * @param defaultValues - Optional default values for form fields
 * @param callbacks - Optional callbacks for form buttons
 * @returns Array of form field configurations
 */
export const createSendDocusignFormFields = (
  defaultValues?: SendDocusignFormDefaultValues,
  callbacks?: SendDocusignFormCallbacks
): FormField[] => [
  {
    id: 'firstName',
    fieldType: 'text',
    name: 'firstName',
    apiKey: 'firstName',
    label: 'FIRST NAME',
    placeholder: 'Enter first name',
    required: true,
    width: 'half',
    defaultValue: defaultValues?.firstName,
    validationMessages: {
      required: 'First name is required',
    },
  },
  {
    id: 'lastName',
    fieldType: 'text',
    name: 'lastName',
    apiKey: 'lastName',
    label: 'LAST NAME',
    placeholder: 'Enter last name',
    required: true,
    width: 'half',
    defaultValue: defaultValues?.lastName,
    validationMessages: {
      required: 'Last name is required',
    },
  },
  {
    id: 'email',
    fieldType: 'email',
    name: 'email',
    apiKey: 'email',
    label: 'EMAIL',
    placeholder: 'Enter email address',
    required: true,
    width: 'full',
    defaultValue: defaultValues?.email,
    validationMessages: {
      required: 'Email is required',
      pattern: 'Please enter a valid email address',
    },
  },
  {
    id: 'placeOnHold',
    fieldType: 'checkbox',
    name: 'placeOnHold',
    apiKey: 'placeOnHold',
    label: 'Place vehicle on hold as order is placed.',
    required: false,
    width: 'full',
  },
  {
    id: 'formButtons',
    fieldType: 'buttonGroup',
    align: 'left',
    buttons: [
      {
        id: 'cancelButton',
        label: 'CANCEL',
        type: 'secondary',
        size: 'medium',
        isFluid: true,
        color: 'neutral',
        onClick: (_data: FieldValues) => {
          callbacks?.onCancel?.();
        },
      },
      {
        id: 'submitButton',
        label: 'SEND',
        type: 'primary',
        size: 'medium',
        isFluid: true,
        color: 'neutral',
      },
    ],
  },
];
